export function loadPageCache(key) {
  try {
    const raw = sessionStorage.getItem(`page_cache_${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function savePageCache(key, data) {
  try {
    sessionStorage.setItem(`page_cache_${key}`, JSON.stringify(data));
  } catch {}
}
